/* unplugin-vue-components disabled */import { render } from "./xcheckboxGroup.vue?vue&type=template&id=147b230c"
import script from "./xcheckboxGroup.vue?vue&type=script&lang=js"
export * from "./xcheckboxGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__